import {NgModule} from '@angular/core';
import {Http, HttpModule, RequestOptions} from '@angular/http';
import {AuthHttp, AuthConfig} from 'angular2-jwt';
import {AuthService} from './auth.service';
import {environment} from 'environments/environment';
import {HttpClientModule} from '@angular/common/http';

export function authHttpServiceFactory(http: Http, options: RequestOptions) {
    return new AuthHttp(new AuthConfig({
        tokenName: environment.tokenName,
        headerPrefix: '',
        tokenGetter: (() => localStorage.getItem(environment.tokenName)),
        globalHeaders: [{'Content-Type': 'application/json'}],
    }), http, options);
}

@NgModule({
    imports: [
        HttpModule,
        HttpClientModule,
    ],
    providers: [
        /*
        {
            provide: AuthHttp,
            useFactory: authHttpServiceFactory,
            deps: [Http, RequestOptions]
        },
        */
        AuthService
    ]
})
export class SecurityModule {
}



// WEBPACK FOOTER //
// ./src/app/core/security/security.module.ts